export const setCookie = (name: string, value: string) => {
  document.cookie += `${name}=${value};`
}
export const checkCookie = (name: string) => document.cookie.includes(`${name}=`);
export const getCookie = (name: string) => document.cookie.match(new RegExp(`${name}=([^;]+)`))?.[1] || '';


export const replaceCookies = (obj: { [key: string]: string }) => {
  document.cookie = Object.entries(obj).map(ob => ob.join('=')).join(';')
}

export const dateToInput = (date?: string) => {
  if (!date) date = Intl.DateTimeFormat('fr-CA', {
    timeZone: 'America/Panama',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(new Date());
  return date.substring(0, 10);
}

export const dateToRegister = (date?: string) => {
  if (!date) date = Intl.DateTimeFormat('fr-CA', {
    timeZone: 'America/Panama',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date());
  return date.substring(0, 10);
}

export const getColorByStatusPeso = (status: string) => ({
  '10': 'text-warning',
  '15': 'text-success',
})[status] || 'text-primary';